export default __webpack_public_path__ + "static/media/258.4b2a9255.jpg";